<template>
  <div class="bdcnt">
    <div class="breadcrumb light">
      <a v-for="(item, index) in items" :key="index" href="#" @click.prevent>
        {{ item }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.breadcrumb {
  margin: 0;
  padding: 0;
  border-width: 1px;
  border-style: solid;
}

.breadcrumb,
.breadcrumb a {
  display: inline-block;
}

.breadcrumb a {
  text-rendering: optimizeLegibility;
  text-decoration: none;
  height: 26px;
  line-height: 26px;
  padding: 0 7px 0 14px;
  position: relative;
  font-size: 0.8rem;
  font-family: inherit;
}

.breadcrumb a:first-child {
  padding-left: 11px;
}

.breadcrumb a:last-child {
  padding-right: 11px;
  pointer-events: none;
  cursor: default;
}

.breadcrumb a:last-child:after,
.breadcrumb a:last-child:before {
  border: 0;
}

.breadcrumb a:after,
.breadcrumb a:before {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  border-left: 7px solid transparent;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 100%;
  z-index: 2;
}

.breadcrumb a:before {
  margin-left: 1px;
  z-index: 1;
}

.light {
  border-color: #9c9e9e;
}

.light a {
  color: #5a6a85;
  background-color: #e5e9e9;
  text-shadow: 0 -1px rgba(255, 255, 255, 0.7);
  box-shadow: inset 0 1px 0 #fff;
}

.light a:after {
  border-left-color: #e5e9e9;
}

.light a:before {
  border-left-color: #9c9e9e;
}

.light a:hover,
.light a:focus {
  background: #edf1f1;
}

.light a:hover:after {
  border-left-color: #edf1f1;
}

.light a:active:before {
  border-left-color: #edf1f1;
}

.light a:last-child {
  background-color: #d3d7d7;
}

.bdcnt {
  margin: 0;
}
</style>
